// extracted by mini-css-extract-plugin
module.exports = {"modale-container":"Modale_modale-container__EXpiF","is-active":"Modale_is-active__Gv0-w","modale":"Modale_modale__2Azpf","close":"Modale_close__3oyHk"};